import BaseError from './BaseError';

class CancelError extends BaseError {}

export default CancelError;
